import { React } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import styles from './NotFound.module.css';
import { useDocumentHead } from '../../hooks/useDocumentHead';

const NotFound = () => {
    useDocumentHead(
        'Page Not Found | TopSpeaks',
        'The requested page could not be found. Return to our speaking tools and coaching services.',
        'noindex, follow'
    );
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.errorSection}>
                    <div className={styles.errorCode}>404</div>
                    <h1 className={styles.title}>Page Not Found</h1>
                    <p className={styles.description}>
                        The page you're looking for doesn't exist or has been moved.
                        Please check the URL or try navigating back.
                    </p>
                    <div className={styles.actions}>
                        <button
                            className={`${styles.button} ${styles.primaryButton}`}
                            onClick={handleGoHome}
                        >
                            <Home size={20} />
                            Go to Home
                        </button>
                        <button
                            className={`${styles.button} ${styles.secondaryButton}`}
                            onClick={handleGoBack}
                        >
                            <ArrowLeft size={20} />
                            Go Back
                        </button>
                    </div>
                </div>
                <div className={styles.illustration}>
                    <svg
                        viewBox="0 0 200 200"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={styles.svg}
                    >
                        <path
                            d="M100 20C55.8172 20 20 55.8172 20 100C20 144.183 55.8172 180 100 180C144.183 180 180 144.183 180 100C180 55.8172 144.183 20 100 20ZM100 160C66.8629 160 40 133.137 40 100C40 66.8629 66.8629 40 100 40C133.137 40 160 66.8629 160 100C160 133.137 133.137 160 100 160Z"
                            fill="currentColor"
                            className={styles.illustrationPath}
                        />
                        <path
                            d="M100 120C111.046 120 120 111.046 120 100C120 88.9543 111.046 80 100 80C88.9543 80 80 88.9543 80 100C80 111.046 88.9543 120 100 120Z"
                            fill="currentColor"
                            className={styles.illustrationCenter}
                        />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default NotFound;